<template>
    <div class="multi-select">
        <p class="form--input">
            <label>{{label}}</label>
        <div class="divider-md"></div>

        <button class="multi-select__button" :class="errorClass" type="button" @click.prevent.stop="toggleMenu">
            <span v-if="activeItemName">{{activeItemName}}</span><span v-else class="placeholder-wrapper">{{placeholder}}</span>
            <i :class="{'arrow-rotate':isOpen}" class="pull-right icons8-joblist-sort-down-01 drop-down-arrow"></i>
        </button>

        <div class="list-wrapper" :class="{show: isOpen}">
            <grid :rwd="{compact: 'stack'}" v-if="multirow">
                <grid-item size="1/3" :rwd="{tablet:'1/3', compact:'1/1'}" v-for="(block, index) in list" :key="index">
                    <ul class="list--unstyled">
                        <li v-for="item in block" :key="item.id" @click="toggleItem(item)"
                            :class="{active: activeItemId&&(activeItemId===item.id)}">
                            <button type="button"><span>{{item.name}}</span></button>
                        </li>
                    </ul>
                </grid-item>
            </grid>
            <div v-else>
                <ul class="list--unstyled">
                    <li v-for="item in list" :key="item.id" @click="toggleItem(item)"
                        :class="{active: activeItemId&&(activeItemId===item.id)}">
                        <button type="button"><span>{{item.name}}</span></button>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import BasicButton from '../BasicButton'

    export default {
        name: 'single-select',
        components: {
            BasicButton
        },
        props: {
            errorClass: Object,
            errors: {},
            label: String,
            placeholder: String,
            list: Array,
            value: {
                required: true
            },
            multirow: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                activeItemId: null,
                activeItemName: null,
                isOpen: false
            }
        },
        computed: {},
        methods: {
            toggleItem(item) {
                this.activeItemName = item.name;
                this.activeItemId = item.id;
                this.toggleMenu();
                this.$emit('input', item.id);
            },
            toggleMenu() {
                this.isOpen = !this.isOpen
            },
            closeOnClickOutside({target}) {
                if (!target.closest('#' + this.id)) {
                    this.isOpen = false
                }
            }
        },
        watch: {
            value(){
                if(this.value === null){
                    this.activeItemName = null;
                }
            },
            isOpen(val) {
                if (val) {
                    window.addEventListener('click', this.closeOnClickOutside)
                } else {
                    window.removeEventListener('click', this.closeOnClickOutside)
                }
            }
        }
    }
</script>

<style scoped lang="scss" type="text/scss">
    @import "../../assets/scss/mixins";
    @import "../../assets/scss/globals";

    .drop-down-arrow {
        transition: transform 1s;
        -webkit-transition: transform 1s;
    }

    .arrow-rotate {
        transform: rotate(180deg);
    }

    .placeholder-wrapper {
        color: #afafaf;
    }

    .multi-select__button {
        cursor: pointer;
        padding: .65em;
        padding-left: 25px;
        width: 100%;
        border-radius: 3px;
        background-color: white;
        outline: none;
        color: #1a1a1a;
        border: 1px solid #1a1a1a;
        transition: all 2ms;
        font-size: 16px;
        font-weight: 400;
        font-family: "Inter UI", sans-serif;
        letter-spacing: 0.36px;
        -webkit-transition: all 2ms;
        transition: all 2ms;
        text-align: left;
    }

    .error {
        border-color: red;
        background: #FDD;
    }

    .error:focus {
        outline-color: #F99;
    }

    .valid {
        border-color: #70c165;
    }

    .valid:focus {
        outline-color: #70c165;
    }

    .multi-select {
        width: 100%;
        display: inline-block;
        position: relative;

        &__button {
            width: 100%;
        }
    }

    .list-wrapper {
        position: absolute;
        z-index: 1;
        background-color: #fff;
        border-radius: 4px;
        color: #444;
        width: 100%;
        transform: translateY(-10px);
        -webkit-box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.15);
        -moz-box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.15);
        box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.15);
        visibility: hidden;
        opacity: 0;
        transition: 0.2s ease-in-out;
        transition-property: transform, opacity, visibility;
        padding: 18px;

        &.show {
            visibility: visible;
            opacity: 1;
            transform: translateY(0px);
        }
    }

    ul {
        margin: 0;
        padding: 0;
    }

    li {
        white-space: nowrap;
        line-height: 2;

        button {
            @include button-reset;
            position: relative;
            font-family: $font-paragraphs;
            font-size: .9rem;
            display: block;
            width: 100%;
            padding: 0 0.75em;
            text-align: left;
            transition: all 0.2s ease-in-out;

            span {
                transition: transform 0.2s ease-in-out;
            }

            &:hover,
            &:focus {
                color: #eb595c;
            }
        }

        &.active {
            font-weight: bold;
            color: #eb595c;

            span {
                display: inline-block;
            }

            button::before {
                visibility: visible;
            }
        }

    }
    .form--input {
        margin-bottom: 20px;
        margin-top: 50px;
        label{
            font-family: "Inter UI", sans-serif;
            font-size: 22px;
            line-height: 28px;
            letter-spacing: 0.02px;
            font-weight: 400;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/common/SingleSelect.vue